import React from "react";
import EsriNetwork from "../assets/svg/esri-network.svg";
import ArcGisMarketPlace from "../assets/arcgis-marketplace-provider.png";
import ArcGisOnline from "../assets/svg/arcgis-online.svg";
import ArcGisUrban from "../assets/svg/arc-gis-urban.svg";
import ArcGisLocalGovt from "../assets/svg/arc-local-government.svg";
import ReleaseReady from "../assets/svg/release-ready.svg";
import GeoLocatorSmall from "../assets/geolocator-small.png";
import GeoZoneSmall from "../assets/geozone-small.png";
import GeoCommentSmall from "../assets/geocomment-small.png";
import UrbanLaunchKitSmall from "../assets/urban-launch-kit-small.png";
import MarketPlaceBG from "../assets/marketplace-bg.png";
import Button from "../components/Button";
import CardFooter from "./CardFooter";
import CopyrightFooter from "./CopyrightFooter";
const EsriFooter = () => {
  return (
    <div className="mt-12">
      <h2 className="font-bold text-xle mb-2">Find us on Esri Marketplace</h2>
      <p>Click here to engage with us directly on Esri marketplace - easy and efficient one click interaction method.</p>
      <div
        className="custom-esri-footer-box-container bg-center bg-contain xl:space-x-4 justify-between flex mt-4 flex-wrap xl:flex-nowrap bg-no-repeat pt-2 pb-4"
        style={{ backgroundImage: `url(${MarketPlaceBG})` }}
      >
        <CardFooter
          link="https://www.esri.com/en-us/arcgis-marketplace/listing/products/49a98badee214910a426838484bdeb63"
          logo={GeoZoneSmall}
          title="GeoZone - Automation for Planning &amp; Zoning"
          productBy="By ViewPro GIS"
          subtitle="App"
        />
        <CardFooter
          link="https://www.esri.com/en-us/arcgis-marketplace/listing/services/6bb226191c3244b9a6552eb62537b3bc"
          logo={UrbanLaunchKitSmall}
          title="ArcGIS Urban Launch Kit"
          productBy="By ViewPro GIS"
          subtitle="Professioal Services"
        />
        <CardFooter
          link="https://www.esri.com/en-us/arcgis-marketplace/listing/products/cabfd0ecc7274cb59efaa6fcb1d479c3"
          logo={GeoLocatorSmall}
          title="GeoLocator - Automation for Economic Development"
          productBy="By ViewPro GIS"
          subtitle="App"
        />
        <CardFooter
          link="https://www.esri.com/en-us/arcgis-marketplace/listing/products/a537d75a2b7d4b9c8519104b4cf60020"
          logo={GeoCommentSmall}
          title="GeoComment - Automation for Citizen Engagement"
          productBy="By ViewPro GIS"
          subtitle="App"
        />
      </div>
      <div className="flex flex-wrap xl:flex-nowrap justify-between items-center mt-5">
        <div>
          <img src={EsriNetwork} alt="" className="mr-5 mb-5 xl:mb-0" />
        </div>
        <div className="flex flex-wrap xl:flex-nowrap items-center">
          <img src={ArcGisMarketPlace} alt="" width="135" className="mr-5 mb-5 xl:mb-0" />
          <img src={ArcGisOnline} alt="" className="mr-5  mb-5 xl:mb-0" />
          <img src={ArcGisUrban} alt="" className="mr-5  mb-5 xl:mb-0" />
          <img src={ArcGisLocalGovt} alt="" className="mr-5  mb-5 xl:mb-0" />
          <img src={ReleaseReady} alt="" />
        </div>
      </div>
      <div className="flex justify-center py-10 border-b border-vp-lightbrown">
        <Button
          btnStyle="primary"
          onClick={() => {
            window.open(
              "https://www.esri.com/en-us/arcgis-marketplace/products?product=App&q=-+automation",
              "_blank"
            );
          }}
          text="Go to Esri Marketplace"
        />
      </div>
      <CopyrightFooter />
    </div>
  );
};

export default EsriFooter;
